import React from "react";
import Description from "./Description";
import k_1 from "../assets/images/k_1-min.png";

const PhotoDetails = () => {
  return (
    <div className="w-11/12 mx-auto">
      <div className="flex flex-col lg:flex-row md:flex-row">
        <div className="overflow-y-scroll relative lg:max-h-[800px] ">
          <img className="lg:w-[700px] p_img" src={k_1} alt="" />
        </div>
        <Description
          name={"Fruit shop"}
          d1={`Completed a front-end app for an Independent service provider as a
          photographer.`}
          d2={`The photo details section was integrated with some suggested photos.`}
          d3={`Forgot password, email verification, and user’s profile update
          process-based authentication was implemented.`}
          d4={"A photographer's daily work and his album added in this site"}
          d5={"This sites were designed by React bootstrap."}
          d6={"React.js, React bootstrap, Firebase, Netlify, React Router."}
          live={"https://celebrated-faun-dfa454.netlify.app/"}
          git={"https://github.com/Kibria934/K.H-Photography"}
        />
      </div>
    </div>
  );
};

export default PhotoDetails;
